/**
 * Common utils
 */
const Utils = {
  /**
   * @param {Number} ncharacters
   */
  randomKey: (ncharacters = 20) => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let text = "+";
    for (let i = 0; i < ncharacters ; i++)
      text = text.concat(chars.charAt(Math.floor(Math.random() * chars.length)));
    return text;
  },
  /**
   * 
   */
  getOrigin: () => {
    return (window.location != window.parent.location) ?
      document.referrer : document.location.href;
  },
  /**
   * getProp
   * @param {Object} data - Target Object
   * @param {Array} tree - Example: ['nodes', '1_0', 'responses', '0', 'text']
   * @param {*} def - Default value on tree error
   */
  getProp: (data, tree, def) => {
    let iterator = JSON.parse(JSON.stringify(data));
    try {
      for (let i = 0; i < tree.length; i++)
        iterator = iterator[tree[i]];
      return iterator === undefined ? def : iterator;
    } catch(e) {
      return def;
    }
  }
};

export default Utils;


// WEBPACK FOOTER //
// ../UmiCore/src/utils/Utils.js